// @flow

import React from 'react'

// Constants
import { SUPPORT_PHONE_NUMBER } from 'hfty'

// Style
import { styles as s } from './style'

export default function Header (): React.Element<any> {
  return (
    <div style={s.header}>
      <span style={s.headerTitle}>
        Order Form
      </span>
      <span style={s.headerPhone}>
        * Call us if you have any questions — {SUPPORT_PHONE_NUMBER} *
      </span>
    </div>
  )
}
